<template>
  <!-- 弹框组件 -->
  <el-dialog
    custom-class="attr-pop share-pop"
    :title="popTitle"
    :visible.sync="showPopAdd"
    :before-close="hidePopAttr"
    :modal-append-to-body="false"
  >
    <p class="share-desc m-40">发送链接或二维码给员工，员工可自行完成员工注册并添加至店铺操作</p>
    <div class="share-main">
      <el-input class="share-link-input" placeholder="数据读取中，请稍候" v-model="link" readonly :disabled="true"></el-input>
      <el-button class="cre-activity-btn copy-btn" @click="handleCopy" type="danger">复制</el-button>
      
    </div>
    <div class="share-main mt-40">
      <img
        class="qrcode"
        :src="codeImg"
        title="加载中..."
      />
      <span class='download-code' @click="handleSave">下载二维码</span>
    </div>
    <el-input class="share-link-input-copy" v-model="link" readonly style="opacity: 0"></el-input>
  </el-dialog>
</template>
<script>
export default {
  props: ["showPopAdd",'link','codeImg'],
  data() {
    return {
      popTitle: "邀请加入",
    };
  },
  methods: {
    hidePopAttr() {
      this.$emit("popfn", false);
    },
    handleCopy() {
      var ele=document.querySelector('.share-link-input-copy input');
      // 选择对象  
      ele.select(); 
      // 执行浏览器复制命令
      var ss = document.execCommand("Copy"); 
      if (ss) {
        this.$popup('复制成功', 'success');
      }
    },
    handleSave(){
      // 创建图片元素
      var img = new Image();
      //设置图片跨域
      img.setAttribute("crossOrigin", "anonymous");
      //设置图片路径
      img.src = this.codeImg;
      //下载图片
      img.onload = function() {
          //创建画布
        var can =  document.createElement("canvas");
          //设置画布大小
        can.width=150;
        can.height = 150;
        let ctx = can.getContext("2d");
          //绘制图片
        ctx.drawImage(img,0,0,150,150);
          //得到图片的base64编码数据
        var newurl = can.toDataURL("image/png"); 
          // 生成一个a元素
        var a = document.createElement("a"); 
          // 创建一个单击事件
        var event = new MouseEvent("click"); 
          // 设置图片名称
        a.download = "活动推广二维码.jpg"; 
          // 将生成的URL设置为a.href属性
        a.href = newurl; 
          // 触发a的单击事件
        a.dispatchEvent(event); 
      }
    }
  },
};
</script>
<style lang="less">
.el-dialog.share-pop {
  .el-form-item__error {
    left: 92px;
  }
  margin-top: 22.8vh;
  width: 878px;
  height: 587px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #ffffff;
  padding: 0;
  .share-link-title {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 0;
    color: #2b3f57;
    font-weight: bold;
  }
  .share-desc {
    color: @SAASFONTCOLOR;
    text-align: center;
    font-size: 14px;
  }
  .share-main {
    text-align: center;
    .el-input.is-disabled .el-input__inner {
      background: @DISABLE;
    }
    .copy-btn {
      width: 100px;
      margin-left: 20px;
      background-color: @SAASCOLOR;
    }
  }
  .qrcode {
    width: 250px;
    height: 250px;
  }
  .share-link-input {
    width: 400px;
  }
  .download-code {
    color: #ff3a3a;
    font-size: 16px;
    display: block;
    cursor: pointer;
  }
  .el-dialog__header {
    height: 40px;
    line-height: 40px;
    padding: 0;
    padding-left: 20px;
    text-align: left;
    background: #f7f8fa;
  }
  .el-dialog__title {
    font-size: 16px;
    text-align: left;
    color: #2b3f57;
    padding-left: 6px;
    margin-bottom: 18px;
    border-left: none;
  }
  .el-dialog__headerbtn {
    top: 11px;
  }
  .el-dialog__body {
    padding: 0;
    height: calc(100vh - 400px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    .el-scrollbar__thumb {
      background-color: #c5c5c5;
    }
  }
  .el-form {
    padding: 20px 30px;
    border-top: 1px solid #f6f8fb;
    .el-form-item {
      margin-bottom: 0;
      &.pop-btn-wrap .el-form-item__content {
        margin-top: 16px;
        text-align: right;
      }
      .item-des {
        font-size: 12px;
        line-height: 28px;
        color: #ff6529;
        padding-left: 92px;
      }
      .el-input {
        width: 300px;
      }
      .el-input__inner {
        width: 100%;
        height: 45px;
        background: #f6f8fb;
        border-radius: 0;
        line-height: 45px;
      }
      .item-btn {
        width: 88px;
        height: 37px;
        padding: 0;
        text-align: center;
        line-height: 37px;
        background: #f6f8fb;
        border-radius: 19px;
        border: none;
        span {
          color: #8d8f96;
        }
      }
      .item-btn.active {
        color: #ffffff;
        background: #2e71fe;
        span {
          color: #ffffff;
        }
      }
      .el-form-item__label {
        color: #081234;
      }
      .el-form-item__content {
        color: #8d8f96;
        text-align: left;
      }
    }
    .top-line {
      margin-top: 15px;
      padding-top: 8px;
      border-top: 1px solid #f6f8fb;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popover/popInvite.vue